import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PageNotFoundComponent } from './defaultScreens/page-not-found/page-not-found.component';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { HTTP_INTERCEPTORS, HttpClientModule, provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { Auth } from './customInterceptors/auth.interceptor';
import { ErrorInterceptor } from './customInterceptors/error.interceptor';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { HighchartsChartModule } from 'highcharts-angular';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { userManagementReducer } from './store/userManagement/reducers/user-management.reducer';
import { articlePollCategoryManagementReducer } from './store/articlePollCategoryManagement/reducers/article-poll-category-management.reducer';
import { advertisementManagementReducer } from './store/advertisement/reducers/advertisement-management.reducer';
import { securityReducer } from './store/security/reducers/security.reducer';
import { feedbackReducer } from './store/feedback/reducers/feedback.reducer';
import { notificationReducer } from './store/notification/reducers/notification.reducer';
import { globalReducer } from './store/global/reducers/global.reducer';
import { environment } from '../environments/environment';
import { EncryptionInterceptor } from './customInterceptors/interseptor';

@NgModule({
  declarations: [
    AppComponent,
    PageNotFoundComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgMultiSelectDropDownModule.forRoot(),
    HighchartsChartModule,
    StoreModule.forRoot({
      global: globalReducer,
      userManagement: userManagementReducer,
      articlePollCategoryManagement: articlePollCategoryManagementReducer,
      advertisementManagement: advertisementManagementReducer,
      security: securityReducer,
      feedback: feedbackReducer,
      notification: notificationReducer
    }),
    StoreDevtoolsModule.instrument({
      maxAge: 25,
      logOnly: environment.production, // Restrict extension to log-only mode
    }),

  ],
  providers: [
    provideAnimationsAsync(),
    provideHttpClient(),
    provideHttpClient(withInterceptorsFromDi()),
    { provide: HTTP_INTERCEPTORS, useClass: Auth, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: EncryptionInterceptor, multi: true }
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
